<template>

    <div>
        <TowerSettings
            v-if="entity.id"
            :entity-type="BUSINESS_TYPE.ENTITY"
            :entity-id="+entity.id"
        >
            <template v-slot:tabs>
                <EntityTabLinks />
            </template>
        </TowerSettings>
    </div>

</template>

<script>
    import EntityTabLinks from '@/components/entities/EntityTabLinks';
    import TowerSettings from '@/components/tower-settings/TowerSettings';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'RestaurantTowerSettings',

        components: {
            TowerSettings,
            EntityTabLinks
        },
  
        data () {
            return {
                BUSINESS_TYPE,
                entity: {}
            }
        },
    
        computed: {},

        async mounted() {
            const id = this.$route.params.id;
            this.entity = (await this.axios.get(`/entities/get/${id}`)).data;
        },

        methods: {}
    }
</script>
